import {
    Card,
    Column,
    Container,
    Gap,
    Gutter,
    Row,
    RowCols,
    Stack,
    StackDirection,
    Text,
    Wrapper,
} from "@rebootui";
import { Link } from "react-router-dom";
import { compoLibraryCategories } from "../../data/compoLibrary";
import Icon from "../common/Icon";

const CompoLibrary = () => {
    return (
        <section className="py-md-7 py-6 bg-gray">
            <Container>
                <Wrapper className="text-center mb-6">
                    <Text className="h2 mb-3">Complete Component Library</Text>
                    <Text className="fs-5 mb-0 text-secondary">
                        Everything you need to build modern interfaces.
                    </Text>
                </Wrapper>
                <Row
                    cols={[
                        RowCols.RowColsLg3,
                        RowCols.RowColsSm2,
                        RowCols.RowCols1,
                    ]}
                    gutter={Gutter.G4}
                >
                    {compoLibraryCategories.map((lib) => (
                        <Column key={lib.title}>
                            <Wrapper className="position-relative zi-99 h-100">
                                <Wrapper
                                    className={`position-absolute top-0 start-0 w-100 blur-box ${lib.glow || ""}`}
                                >
                                    {null}
                                </Wrapper>
                                <Card className="shadow-s shadow-m-hover tr-base h-100 rounded-4 border border-opacity-10">
                                    <Card.Body className="p-4">
                                        <Wrapper
                                            className={`d-inline-block mb-3 text-${lib.color} bg-${lib.color} bg-opacity-5 rounded-4 p-3 shadow-s`}
                                        >
                                            <Icon
                                                name={lib.icon}
                                                width={28}
                                                height={28}
                                            />
                                        </Wrapper>
                                        <Text className="h5 mb-m text-dark">
                                            {lib.title}
                                        </Text>
                                        <Row cols={RowCols.RowCols2} gutter={Gutter.G2}>
                                            {lib.items.map((item) => (
                                                <Column key={item.to}>
                                                    <Stack
                                                        direction={
                                                            StackDirection.Row
                                                        }
                                                        gap={Gap.Gap2}
                                                        className="align-items-center"
                                                    >
                                                        <Stack.Item className="text-muted opacity-40 flex-shrink-0">
                                                            <Icon
                                                                name="bullet"
                                                                width={4}
                                                                height={4}
                                                            />
                                                        </Stack.Item>
                                                        <Stack.Item className="min-w-0">
                                                            <Link
                                                                to={item.to}
                                                                className="small text-secondary text-dark-hover tr-base text-decoration-none d-inline-block"
                                                            >
                                                                {item.label}
                                                            </Link>
                                                        </Stack.Item>
                                                    </Stack>
                                                </Column>
                                            ))}
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Wrapper>
                        </Column>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default CompoLibrary;
